export default __webpack_public_path__ + "static/main_mobile_v3_hy-0381c24c1bec13a033f8efe846411c3d.mp4";